import { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  InputNumber,
  Upload,
  message,
} from "antd";
import { getDirectusClient } from "../../../lib/directus";
import Layouts from "../../../components/Layouts";
import {
  MinusCircleOutlined,
  PlusOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { redirect, useNavigate } from "react-router-dom";
import { createItem, createItems, readItems, uploadFiles } from "@directus/sdk";
import * as pdfjs from "pdfjs-dist";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Dragger } = Upload;
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();
const OrdersCreate = () => {
  const navigate = useNavigate();
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [estados, setEstado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);

  const [cantidad, setCatidad] = useState(null);
  const [precio, setPrecio] = useState(null);
  const [desceunto, setDescuento] = useState(null);
  const [valosim, setValosim] = useState(null);
  const [iditem, setIditem] = useState(null);

  const [totalprice, setTotalprice] = useState(0);

  const [form] = useForm();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [fileId, setFileId] = useState(null);
const user = useSelector((state) => state.userdata);
  // Add new state for product taxes
  const [productTaxes, setProductTaxes] = useState({});

  // Add new state variables for different totals
  const [totals, setTotals] = useState({
    subtotal: 0,
    groupTaxTotal: 0,
    iscTotal: 0,
    grandTotal: 0
  });

  useEffect(() => {
    async function fetchProveedores() {
      const directus = await getDirectusClient();
      await directus
        .request(readItems("proveedores", { limit: -1 }))
        .then((proveedores) => {
          setProveedores(proveedores);
        });
    }

    async function fetchProductos() {
      const directus = await getDirectusClient();
      await directus
        .request(readItems("productos", { fields: "*.*", limit: -1 }))
        .then((productos) => {
          setProductos(productos);
        });
    }

    async function fetchEstados() {
      const directus = await getDirectusClient();
      await directus
        .request(readItems("estados_ordenes_compra", { limit: -1 }))
        .then((estados) => {
          setEstado(estados);
        });
    }

    fetchProveedores();
    fetchProductos();
    fetchEstados();
  }, []);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    setLoading(true);

    try {
      const ordenDeCompra = {
        numero_factura: values.numero_factura,
        proveedor: values.proveedor,
        estado: 1,
        fecha: new Date().toISOString().split("T")[0],
        productos: values.productoss,
        comprobante: fileId,
        // Add new fields
        ingresado_por: user.id, // You'll need to implement this
        impuesto_isc: totals.iscTotal,
        impuesto_itbms: totals.groupTaxTotal,
        precio_total: totals.grandTotal,
        subtotal: totals.subtotal,
     
      };

      const orden = await directus.request(
        createItems("ordenes_decompra", ordenDeCompra)
      );

      if (orden.id) {
        message.success("Orden de compra creada exitosamente");
        navigate(`/order_assign/${orden.id}`);
      }
    } catch (error) {
      console.error(error);
      message.error("Error al crear la orden de compra");
    } finally {
      setLoading(false);
    }
  };

  // Add helper function to get current user


  const handleSearch = async (value) => {
    console.log("buscando");
    const directus = await getDirectusClient();
    setLoading(true);
    await directus
      .request(
        readItems("productos", {
          search: value,
          fields: "*.*",
        })
      )
      .then((response) => {
        setProductos(response);
        setLoadings(false);
      });
  };

  const extractData = (text) => {
    console.log("Texto completo recibido:", text); // Debug

    // Extraer número de factura - Modificado para ser más preciso
    const facturaMatch = text.match(/Número de Factura:\s*(FAC-\d+)/);
    const facturaNumber = facturaMatch ? facturaMatch[1].trim() : "";
    console.log("Número de factura encontrado:", facturaNumber); // Debug

    // Extraer proveedor - Modificado para evitar captura excesiva
    const proveedorMatch = text.match(
      /Proveedor:\s*([^\n]+?)(?=\s*PRODUCTOS|$)/
    );
    const proveedorNombre = proveedorMatch ? proveedorMatch[1].trim() : "";
    console.log("Proveedor encontrado:", proveedorNombre); // Debug

    // Extraer productos
    const productos = [];
    // Buscar la sección de PRODUCTOS y dividir por elementos numerados
    const productosRegex =
      /(\d+)\.\s*([^C]+)Cantidad:\s*(\d+)\s*Precio Compra:\s*(\d+)\s*Valor sin Impuestos:\s*(\d+)\s*Descuento Comercial:\s*(\d+)\s*Precio Final:\s*(\d+)/g;

    let match;
    while ((match = productosRegex.exec(text)) !== null) {
      const producto = {
        producto_detalle: match[2].trim(),
        cantidad: parseInt(match[3]),
        precio_compra: parseFloat(match[4]),
        valor_sim: parseFloat(match[5]),
        descuento_comercial: parseFloat(match[6]),
        precio_uni_final: parseFloat(match[7]),
      };
      productos.push(producto);
      console.log("Producto encontrado:", producto); // Debug
    }

    const extractedData = {
      numero_factura: facturaNumber,
      proveedor: proveedorNombre,
      productoss: productos,
    };

    console.log("Datos extraídos finales:", extractedData);
    return extractedData;
  };

  const handleFileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("title", file.name);
      formData.append("type", file.type);

      const directus = await getDirectusClient();
      const response = await directus.request(uploadFiles(formData));

      if (response.id) {
        setFileId(response.id);
        message.success("Archivo subido correctamente");
      }
      return false; // Prevent default upload behavior
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("Error al subir el archivo");
      return false;
    }
  };

  // Update the calculateProductTaxes function
  const calculateProductTaxes = async (productId, precioFinal) => {
    if (!productId || !precioFinal) return null;

    try {
      const directus = await getDirectusClient();

      // Get product with group details
      const product = await directus.request(
        readItems("productos", {
          fields: ["id", "grupo.id", "grupo.impuesto"],
          filter: { id: { _eq: productId } },
        })
      );

      if (!product[0]?.grupo?.id) return null;

      const groupTaxPercentage = parseFloat(product[0].grupo.impuesto || 0);
      const groupTaxAmount = precioFinal * (groupTaxPercentage / 100);
      const totalWithGroupTax = precioFinal + groupTaxAmount;

      // Check for ISC tax directly from impuestos table
      const taxes = await directus.request(
        readItems("impuestos", {
          fields: ["nombre", "porcentaje"],
          filter: {
            gropo: { grupos_id: { _eq: product[0].grupo.id } },
            nombre: { _eq: "ISC" },
          },
        })
      );

      let iscAmount = 0;
      let iscPercentage = 0;

      // If ISC tax exists for this group, calculate it
      if (taxes && taxes[0]?.porcentaje) {
        iscPercentage = parseFloat(taxes[0].porcentaje);
        iscAmount = precioFinal * (iscPercentage / 100);
      }

      const finalTotal = precioFinal + groupTaxAmount + iscAmount;

      return {
        precioBase: precioFinal,
        groupTaxPercentage,
        groupTaxAmount,
        totalWithGroupTax,
        iscPercentage,
        iscAmount,
        finalTotal,
      };
    } catch (error) {
      console.error("Error calculating taxes:", error);
      return null;
    }
  };

  useEffect(() => {
    if (precio === null || iditem === null) return;

    const fields = form.getFieldValue("productoss");
    if (!fields || !fields[iditem]) return;

    const precioCompra = parseFloat(precio?.target?.value || 0);
    const valorSim = parseFloat(valosim?.target?.value || 0);
    const descuento = parseFloat(desceunto?.target?.value || 0);

    // Calculate final price
    const precioFinal = precioCompra + valorSim - descuento;

    // Update the form field
    fields[iditem] = {
      ...fields[iditem],
      precio_uni_final: precioFinal,
    };

    // Set the updated fields back to the form
    form.setFieldsValue({
      productoss: fields,
    });

    // Calculate taxes for this product
    calculateProductTaxes(fields[iditem].producto_detalle, precioFinal).then(
      (taxes) => {
        if (taxes) {
          setProductTaxes((prev) => ({
            ...prev,
            [iditem]: taxes,
          }));
        }
      }
    );
  }, [precio, desceunto, valosim, iditem]);

  // Update the useEffect for total price calculation
  useEffect(() => {
    const fields = form.getFieldValue("productoss");
    if (!fields) return;

    const calculateTotals = async () => {
      let subtotal = 0;
      let groupTaxTotal = 0;
      let iscTotal = 0;

      for (const field of fields) {
        if (!field?.producto_detalle || !field?.precio_uni_final) continue;

        try {
          const taxes = await calculateProductTaxes(
            field.producto_detalle, 
            parseFloat(field.precio_uni_final)
          );

          if (taxes) {
            subtotal += taxes.precioBase;
            groupTaxTotal += taxes.groupTaxAmount;
            iscTotal += taxes.iscAmount;
          }
        } catch (error) {
          console.error('Error calculating totals:', error);
        }
      }

      const grandTotal = subtotal + groupTaxTotal + iscTotal;

      setTotals({
        subtotal,
        groupTaxTotal,
        iscTotal,
        grandTotal
      });
    };

    calculateTotals();
  }, [form.getFieldValue("productoss")]);

  // Add formatted display for the total price
  const formatPrice = (price) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
    }).format(price);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    beforeUpload: handleFileUpload,
    showUploadList: true,
  };
  console.log(productTaxes);

  // Update the tax information display
  const TaxInfo = ({ taxes }) => (
    <div
      style={{
        marginLeft: 8,
        padding: "4px 8px",
        background: "#f5f5f5",
        borderRadius: "4px",
        minWidth: "200px",
      }}
    >
    
      <p style={{ margin: "0 0 4px" }}>
      itbms ({taxes.groupTaxPercentage}%):{" "}
        {formatPrice(taxes.groupTaxAmount)}
      </p>
      <p style={{ margin: "0 0 4px" }}>
        Total + itbms: {formatPrice(taxes.totalWithGroupTax)}
      </p>
      {taxes.iscPercentage > 0 && (
        <p style={{ margin: "0 0 4px" }}>
          ISC ({taxes.iscPercentage}%): {formatPrice(taxes.iscAmount)}
        </p>
      )}
      <p style={{ margin: 0, fontWeight: "bold" }}>
        Total Final: {formatPrice(taxes.finalTotal)}
      </p>
    </div>
  );

  return (
    <Layouts>
      <div className="mb-8 bg-white rounded-lg shadow-sm">
        <Dragger
          {...uploadProps}
          accept=".pdf"
          style={{
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <p className="ant-upload-drag-icon" style={{ marginBottom: "8px" }}>
            <InboxOutlined style={{ fontSize: "24px" }} />
          </p>
          <p
            className="ant-upload-text"
            style={{ fontSize: "14px", marginBottom: "4px" }}
          >
            Haga clic o arrastre un archivo PDF aquí para extraer los datos
          </p>
          <p className="ant-upload-hint" style={{ fontSize: "12px" }}>
            Solo se admiten archivos PDF
          </p>
        </Dragger>
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Factura #"
          name="numero_factura"
          rules={[{ required: true, message: "Please input your factura!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="proveedor"
          label="Proveedor"
          rules={[{ required: true }]}
        >
          <Select>
            {proveedores.map((proveedor) => (
              <Option key={proveedor.id} value={proveedor.id}>
                {proveedor.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.List name="productoss">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: "flex",
                    marginBottom: 8,
                  }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "producto_detalle"]}
                    label="Producto"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Selecciona un producto"
                      showSearch={true}
                      filterOption={false}
                      onSearch={handleSearch}
                      onChange={(value) => console.log(value)}
                      style={{ width: 200 }}
                    >
                      {productos.map((product) => (
                        <Select.Option key={product.id} value={product.id}>
                          {product.nombre}{" "}
                          <span style={{ color: "#20c77c", fontSize: 12 }}>
                            {" "}
                            {product.grupo.nombre}
                          </span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Cantidad #"
                    initialValue={0}
                    name={[name, "cantidad"]}
                    onChange={(v) => {
                      setIditem(name);
                      setCatidad(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="descuento #"
                    type="number"
                    initialValue={0}
                    name={[name, "descuento_comercial"]}
                    onChange={(v) => {
                      setIditem(name);
                      console.log(v);
                      setDescuento(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="precio #"
                    type="number"
                    initialValue={0}
                    name={[name, "precio_compra"]}
                    onChange={(v) => {
                      setIditem(name);
                      console.log(v);
                      setPrecio(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="Valor sim #"
                    type="number"
                    name={[name, "valor_sim"]}
                    initialValue={0}
                    onChange={(v) => {
                      setIditem(name);
                      setValosim(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    label="final v #"
                    type="number"
                    defaulValue={0}
                    initialValue={0}
                    name={[name, "precio_uni_final"]}
                    onChange={(v) => {
                      setIditem(name);
                      //setValosim(v);
                    }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your cantidad!",
                      },
                    ]}
                  >
                    <InputNumber min={0} disabled />
                  </Form.Item>

                  {productTaxes[name] && <TaxInfo taxes={productTaxes[name]} />}

                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  agregar producto
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <div style={{ 
          marginTop: 16, 
          padding: 16, 
          background: '#f5f5f5', 
          borderRadius: 8,
          width: 'fit-content',
          marginLeft: 'auto'
        }}>
          <p style={{ margin: '0 0 8px' }}>Subtotal: {formatPrice(totals.subtotal)}</p>
          <p style={{ margin: '0 0 8px' }}>Impuesto itbms: {formatPrice(totals.groupTaxTotal)}</p>
          <p style={{ margin: '0 0 8px' }}>ISC: {formatPrice(totals.iscTotal)}</p>
          <p style={{ margin: 0, fontWeight: 'bold', borderTop: '1px solid #d9d9d9', paddingTop: 8 }}>
            Total Final: {formatPrice(totals.grandTotal)}
          </p>
        </div>

        <Button type="primary" htmlType="submit">
          Crear orden de compra
        </Button>
      </Form>
    </Layouts>
  );
};

export default OrdersCreate;
